import React from 'react';
import parse from 'html-react-parser';
import ImageGallery from '@@components/ImageGallery/ImageGallery';
import { Accordion } from 'react-bootstrap';
import { isImage, isMedia, TSupplementalContent } from '@@config/wcs';
import { hashKey } from '@@utils/utils';

type TSupplementalsAccordionProps = {
    supplementalContent: TSupplementalContent[];
};

const SupplementalsAccordion: React.FC<TSupplementalsAccordionProps> = ({ supplementalContent }) => {
    return (
        <>
            <p className='title'>More Information Listed in the Report</p>
            <Accordion className='mr-4'>
                {supplementalContent.map((content, index) => (
                    <Accordion.Item eventKey={`${index}`} key={hashKey(content.TITLE)}>
                        <Accordion.Header as='h5' className='w-full flex justify-between'>
                            <span>{parse(content.TITLE)}</span>
                            <span></span>
                        </Accordion.Header>

                        <Accordion.Body className='px-12 py-4'>
                            {content?.['BODY_JSON'].map(item => {
                                return Object.entries(item).map(([key, value]) => {
                                    if (key === 'TITLE' && typeof value === 'string') {
                                        return <h3 key={key}>{value}</h3>;
                                    }

                                    if (key === 'BODY' && Array.isArray(value)) {
                                        return value.map((paragraph, j) => (
                                            <p key={`${key}-${j}`}>{parse(paragraph)}</p>
                                        ));
                                    }

                                    if (key === 'IMAGE' && isImage(value)) {
                                        return (
                                            <img
                                                key={key}
                                                className='max-w-full h-auto mb-2'
                                                src={value['SRC']}
                                                alt={value['ALT_TEXT']}
                                            />
                                        );
                                    }

                                    if (key === 'MEDIA' && isMedia(value)) {
                                        return <ImageGallery key={key} media={value} />;
                                    }

                                    return null;
                                });
                            })}
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </>
    );
};

export type { TSupplementalsAccordionProps };
export default SupplementalsAccordion;
